import { Navigate } from 'react-router';
import { useAppSelector } from '../../redux/hooks.ts';
import { selectHasRentalConfiguration } from '../../redux/features/selectors/orderSelectors.ts';

export const RentalOrderGuard = ({ children }: React.PropsWithChildren) => {
  const hasRentalConfiguration = useAppSelector(selectHasRentalConfiguration);

  if (!hasRentalConfiguration) {
    return <Navigate to="/" />;
  }
  return children;
}
